import MainTitle from '../../components/MainTitle'
import useAuth from '../../hooks/useAuth'
import { useState } from 'react'
import ReportConfirm from '../../components/ReportConfirm'
import Modal from '../../components/Modal'
import useAxiosPrivate from '../../hooks/useAxiosPrivate'
function Reports() {
  const [showReportConfirmation, setShowReportConfirmation] = useState(false)
  const [sessionsReportData, setSessionsReportData] = useState({})
  const [sessionsReportActive, setSessionsReportActive] = useState(false)
  const [sessionsTrashedReportActive, setSessionsTrashedReportActive] = useState(false)
  const [ohSessionsTrashedReportActive, setOhSessionsTrashedReportActive] = useState(false)
  const [sessionsTrashedReportData, setSessionsTrashedReportData] = useState({})
  const [ohSessionsTrashedReportData, setOhSessionsTrashedReportData] = useState({})
  const [modalTitle, setModalTitle] = useState('')
  const [showModal, setShowModal] = useState(false)
  const axios = useAxiosPrivate()

  const SessionsReportModal = () => {
    const sessionReport = async (e) => {
      e.preventDefault()
      resetModal()
      setShowReportConfirmation(true)
      const data = {
        start_date: sessionsReportData.startDate,
        end_date: sessionsReportData.endDate,
      }
      try {
        const response = await axios.post(`/reports/sessions`, data)
      } catch (error) { }
    }

    return (
      <form onSubmit={sessionReport}>
        <div className="mb-3">
          <label
            htmlFor="name"
            className="block font-medium text-gray-600 text-sm"
          >
            Report Start Date
          </label>
          <div className="mt-1 relative rounded-md">
            <input
              type="date"
              name="start_date"
              id="name"
              onChange={(e) => (sessionsReportData.startDate = e.target.value)}
              className="px-4 py-2 block w-full border border-gray-300 rounded-md shadow-md"
            />
          </div>
        </div>

        <div className="mb-3">
          <label
            htmlFor="name"
            className="block font-medium text-gray-600 text-sm"
          >
            Report End Date
          </label>
          <div className="mt-1 relative rounded-md">
            <input
              type="date"
              name="end_date"
              id="name"
              onChange={(e) => (sessionsReportData.endDate = e.target.value)}
              className="px-4 py-2 block w-full border border-gray-300 rounded-md shadow-md"
            />
          </div>
        </div>

        <div className="mb-3">
          <span>
            Note: If you don't select any dates the report will pull all of the
            data available
          </span>
        </div>

        <div className="mb-3 flex justify-between">
          <button
            type="button"
            className="btn red mt-4 w-1/3"
            onClick={resetModal}
          >
            Cancel
          </button>
          <button type="submit" className="btn mt-4 w-1/3">
            Download
          </button>
        </div>
      </form>
    )
  }

  const SessionsTrashedReportModal = () => {
    const sessionTrashedReport = async (e) => {
      e.preventDefault()
      resetModal()
      setShowReportConfirmation(true)
      const data = {
        start_date: sessionsTrashedReportData.startDate,
        end_date: sessionsTrashedReportData.endDate,
      }
      try {
        const response = await axios.post(
          `/reports/sessions-with-trashed`,
          data
        )
      } catch (error) { }
    }

    return (
      <form onSubmit={sessionTrashedReport}>
        <div className="mb-3">
          <label
            htmlFor="name"
            className="block font-medium text-gray-600 text-sm"
          >
            Report Start Date
          </label>
          <div className="mt-1 relative rounded-md">
            <input
              type="date"
              name="start_date"
              id="name"
              onChange={(e) =>
                (sessionsTrashedReportData.startDate = e.target.value)
              }
              className="px-4 py-2 block w-full border border-gray-300 rounded-md shadow-md"
            />
          </div>
        </div>

        <div className="mb-3">
          <label
            htmlFor="name"
            className="block font-medium text-gray-600 text-sm"
          >
            Report End Date
          </label>
          <div className="mt-1 relative rounded-md">
            <input
              type="date"
              name="end_date"
              id="name"
              onChange={(e) =>
                (sessionsTrashedReportData.endDate = e.target.value)
              }
              className="px-4 py-2 block w-full border border-gray-300 rounded-md shadow-md"
            />
          </div>
        </div>

        <div className="mb-3">
          <span>
            Note: If you don't select any dates the report will pull all of the
            data available
          </span>
        </div>

        <div className="mb-3 flex justify-between">
          <button
            type="button"
            className="btn red mt-4 w-1/3"
            onClick={resetModal}
          >
            Cancel
          </button>
          <button type="submit" className="btn mt-4 w-1/3">
            Download
          </button>
        </div>
      </form>
    )
  }

  const OhSessionsTrashedReportModal = () => {
    const ohSessionTrashedReport = async (e) => {
      e.preventDefault()
      resetModal()
      setShowReportConfirmation(true)
      const data = {
        start_date: ohSessionsTrashedReportData.startDate,
        end_date: ohSessionsTrashedReportData.endDate,
      }
      try {
        const response = await axios.post(
          `/reports/oh-sessions-with-trashed`,
          data
        )
      } catch (error) { }
    }

    return (
      <form onSubmit={ohSessionTrashedReport}>
        <div className="mb-3">
          <label
            htmlFor="name"
            className="block font-medium text-gray-600 text-sm"
          >
            Report Start Date
          </label>
          <div className="mt-1 relative rounded-md">
            <input
              type="date"
              name="start_date"
              id="name"
              onChange={(e) =>
                (ohSessionsTrashedReportData.startDate = e.target.value)
              }
              className="px-4 py-2 block w-full border border-gray-300 rounded-md shadow-md"
            />
          </div>
        </div>

        <div className="mb-3">
          <label
            htmlFor="name"
            className="block font-medium text-gray-600 text-sm"
          >
            Report End Date
          </label>
          <div className="mt-1 relative rounded-md">
            <input
              type="date"
              name="end_date"
              id="name"
              onChange={(e) =>
                (ohSessionsTrashedReportData.endDate = e.target.value)
              }
              className="px-4 py-2 block w-full border border-gray-300 rounded-md shadow-md"
            />
          </div>
        </div>

        <div className="mb-3">
          <span>
            Note: If you don't select any dates the report will pull all of the
            data available
          </span>
        </div>

        <div className="mb-3">
          <div className='border-2 rounded-md p-2 mt-2 text-center shadow bg-yellow-100 border-yellow-200'>
            Session costs marked * are missing hourly rates
          </div>
        </div>

        <div className="mb-3 flex justify-between">
          <button
            type="button"
            className="btn red mt-4 w-1/3"
            onClick={resetModal}
          >
            Cancel
          </button>
          <button type="submit" className="btn mt-4 w-1/3">
            Download
          </button>
        </div>
      </form>
    )
  }

  const highMediumClientRisk = async () => {
    setShowReportConfirmation(true)
    try {
      await axios.get(`/reports/clientsRisk`)
    } catch (error) {
      console.error(error)
    }
  }

  const noRiskClients = async () => {
    setShowReportConfirmation(true)
    try {
      await axios.get(`/reports/noClientRisk`)
    } catch (error) {
      console.error(error)
    }
  }

  const noFutureBookings = async () => {
    setShowReportConfirmation(true)
    try {
      await axios.get(`/reports/noFutureBookings`)
    } catch (error) {
      console.error(error)
    }
  }

  const practitionerCancellationsReport = async () => {
    setShowReportConfirmation(true)
    try {
      await axios.get(`/reports/practitioner-cancellations`)
    } catch (error) {
      console.error(error)
    }
  }

  const queryLogReport = async () => {
    setShowReportConfirmation(true)
    try {
      await axios.get(`/reports/query-log`)
    } catch (error) {
      console.error(error)
    }
  }

  const incompleteSessionsReport = async () => {
    setShowReportConfirmation(true)
    try {
      await axios.get(`/reports/incomplete-sessions`)
    } catch (error) {
      console.error(error)
    }
  }

  const coreQuestionnaireReport = async () => {
    setShowReportConfirmation(true)
    try {
      await axios.get(`/reports/core-questionnaire`)
    } catch (error) {
      console.error(error)
    }
  }

  const sessionExtensionReport = async () => {
    setShowReportConfirmation(true)
    try {
      await axios.get(`/reports/session-extension`)
    } catch (error) {
      console.error(error)
    }
  }
  const completedClients = async () => {
    setShowReportConfirmation(true)
    try {
      await axios.get(`/reports/completedClients`)
    } catch (error) {
      console.error(error)
    }
  }

  const assessmentReport2025 = async () => {
    setShowReportConfirmation(true)
    try {
      await axios.get(`/reports/assessment-form-2025`)
    } catch (error) {
      console.error(error)
    }
  }

  const sessionsReportClicked = () => {
    setSessionsReportData({})
    setSessionsReportActive(true)
    setModalTitle(`Sessions Report`)
    setShowModal(true)
  }

  const sessionsTrashedReportClicked = () => {
    setSessionsTrashedReportData({})
    setSessionsTrashedReportActive(true)
    setModalTitle(`Sessions Report`)
    setShowModal(true)
  }

  const ohSessionsTrashedReportClicked = () => {
    setOhSessionsTrashedReportData({})
    setOhSessionsTrashedReportActive(true)
    setModalTitle(`OH Sessions Report`)
    setShowModal(true)
  }

  const resetModal = () => {
    setSessionsReportData({})
    setSessionsReportActive(false)

    setSessionsTrashedReportData({})
    setSessionsTrashedReportActive(false)
    setShowModal(false)
  }

  const ModalBody = () => {
    if (sessionsReportActive) {
      return <SessionsReportModal />
    }

    if (sessionsTrashedReportActive) {
      return <SessionsTrashedReportModal />
    }

    if (ohSessionsTrashedReportActive) {
      return <OhSessionsTrashedReportModal />
    }
  }

  return (
    <section className="relative">
      {showModal && (
        <Modal title={modalTitle} body={<ModalBody />} show={resetModal} />
      )}
      {showReportConfirmation && (
        <ReportConfirm show={setShowReportConfirmation} />
      )}
      <MainTitle title="Reports" />
      <article className="">
        <div className="grid grid-cols-3 xl:grid-cols-4 gap-4 mt-4">
          <div className="p-4 bg-white flex-1 rounded-md shadow-md">
            <div className="text-center font-medium pb-4">
              Sessions breakdown report
            </div>
            <div className="flex justify-center">
              <button
                className="btn green mr-4"
                onClick={sessionsReportClicked}
              >
                Download
              </button>
            </div>
          </div>

          <div className="p-4 bg-white flex-1 rounded-md shadow-md">
            <div className="text-center font-medium pb-4">
              Sessions breakdown report (with deleted clients)
            </div>
            <div className="flex justify-center">
              <button
                className="btn green mr-4"
                onClick={sessionsTrashedReportClicked}
              >
                Download
              </button>
            </div>
          </div>

          <div className="p-4 bg-white flex-1 rounded-md shadow-md">
            <div className="text-center font-medium pb-4">
              Medium & High risk clients report
            </div>
            <div className="flex justify-center">
              <button className="btn green mr-4" onClick={highMediumClientRisk}>
                Download
              </button>
            </div>
          </div>

          <div className="p-4 bg-white flex-1 rounded-md shadow-md">
            <div className="text-center font-medium pb-4">
              Completed Clients
            </div>
            <div className="flex justify-center">
              <button className="btn green mr-4" onClick={completedClients}>
                Download
              </button>
            </div>
          </div>

          <div className="p-4 bg-white flex-1 rounded-md shadow-md">
            <div className="text-center font-medium pb-4">
              No Future Bookings Report
            </div>
            <div className="flex justify-center">
              <button className="btn green mr-4" onClick={noFutureBookings}>
                Download
              </button>
            </div>
          </div>

          <div className="p-4 bg-white flex-1 rounded-md shadow-md">
            <div className="text-center font-medium pb-4">
              Practitioner Cancellations
            </div>
            <div className="flex justify-center">
              <button
                className="btn green mr-4"
                onClick={practitionerCancellationsReport}
              >
                Download
              </button>
            </div>
          </div>
          <div className="p-4 bg-white flex-1 rounded-md shadow-md">
            <div className="text-center font-medium pb-4">
              CORE Questionnaire
            </div>
            <div className="flex justify-center">
              <button
                className="btn green mr-4"
                onClick={coreQuestionnaireReport}
              >
                Download
              </button>
            </div>
          </div>
          <div className="p-4 bg-white flex-1 rounded-md shadow-md">
            <div className="text-center font-medium pb-4">Query Log Report</div>
            <div className="flex justify-center">
              <button className="btn green mr-4" onClick={queryLogReport}>
                Download
              </button>
            </div>
          </div>
          <div className="p-4 bg-white flex-1 rounded-md shadow-md">
            <div className="text-center font-medium pb-4">Incomplete Sessions Report</div>
            <div className="flex justify-center">
              <button className="btn green mr-4" onClick={incompleteSessionsReport}>
                Download
              </button>
            </div>
          </div>
          <div className="p-4 bg-white flex-1 rounded-md shadow-md">
            <div className="text-center font-medium pb-4">Session Extension Report</div>
            <div className="flex justify-center">
              <button className="btn green mr-4" onClick={sessionExtensionReport}>
                Download
              </button>
            </div>
          </div>
          <div className="p-4 bg-white flex-1 rounded-md shadow-md">
            <div className="text-center font-medium pb-4">Assessment Report 2025</div>
            <div className="flex justify-center">
              <button className="btn green mr-4" onClick={assessmentReport2025}>
                Download
              </button>
            </div>
          </div>
        </div>
      </article>
      <div className='mt-5'></div>
      <MainTitle title="OH Reports"/>
      <article className="">
        <div className="grid grid-cols-3 xl:grid-cols-4 gap-4 mt-4">
          <div className="p-4 bg-white flex-1 rounded-md shadow-md">
            <div className="text-center font-medium pb-4">
              OH Sessions breakdown report (with deleted clients)
            </div>
            <div className="flex justify-center">
              <button
                className="btn green mr-4"
                onClick={ohSessionsTrashedReportClicked}
              >
                Download
              </button>
            </div>
          </div>
        </div>
      </article>
    </section>
  )
}

export default Reports
